query CorporateWorkgroupsItems {
  corporateWorkgroups(orderBy: [NAME_ASC, PRIMARY_KEY_ASC]) {
    nodes {
      id
      name
    }
  }
}
